import React from 'react';
import ColorsMain from "../../colors/ColorsMain.js";

const ButtonWhite = ({
    label = "",
    onClick = () => { },
    className = "",
    Icon,
    fill = '#5E5E6329',
    loading = false,
    isDisabled = false
}) => {
    const buttonStyles = {
        background: isDisabled ? "#a9a9a9" : ColorsMain.bgButtonWhite,
        cursor: isDisabled ? "not-allowed" : "pointer"
    };

    const textStyles = {
        color: isDisabled ? '#2B2B33' : ColorsMain.textBlackButton,
        fontWeight: 500
    };

    // Aplicar mt-2 solo si no se proporciona className
    const buttonClassName = className
        ? `px-4 py-3 min-w-[105px] rounded-xl flex items-center justify-center gap-2 ${className}`
        : `px-4 py-3 min-w-[105px] rounded-xl flex items-center justify-center gap-2 mt-2`;

    return (
        <button
            style={buttonStyles}
            className={buttonClassName}
            onClick={!loading ? onClick : null}
            disabled={isDisabled}
        >
            {loading ? (
                <div className="spinner-border animate-spin w-5 h-5 border-2 border-gray-300 border-t-transparent rounded-full" />
            ) : (
                <p style={textStyles}>{label}</p>
            )}
            {Icon && !loading && (
                <Icon
                    className="w-5 h-5 text-gray-700"
                    style={{ fill, width: "20px", height: "20px" }}
                />
            )}
        </button>
    );
};

export default ButtonWhite;
